export var PLATFORM = "web";
